import requests from "./httpServiceKey";
const LoginService = {
  // registerAdmin: async (body) => {
  //   return requests.post("/admin/register", body);
  // },
 
  loginEmployee: async (body) => {
    return requests.post(`/employee/login`, body);
  },

  forgetPassword: async (body) => {
    return requests.put("/employee/forgot-password", body);
  },

  resetPassword: async (body) => {
    return requests.put("/employee/reset-password", body);
  },

  // signUpWithProvider: async (body) => {
  //   return requests.post("/admin/signup", body);
  // },

  
};

export default LoginService;
